import { ToastProgrammatic as Toast } from 'buefy';

const Toaster = {};

Toaster.install = (Vue) => {
  Vue.prototype.$toast = {
    success(message, duration = 3000, position = 'is-bottom') {
      Toast.open({
        duration,
        message,
        position,
        type: 'is-success',
      });
    },
    error(message, duration = 3000, position = 'is-bottom') {
      Toast.open({
        duration,
        message,
        position,
        type: 'is-danger',
      });
    },
    warning(message, duration = 3000, position = 'is-top') {
      Toast.open({
        duration,
        message,
        position,
        type: 'is-warning',
      });
    },
    notification(message, duration = 3000, position = 'is-top') {
      Toast.open({
        duration,
        message,
        position,
        type: 'is-info',
      });
    },
  };
};

export default Toaster;
